<script lang="tsx" setup>
import TextFilter from '../filter/TextFilter.vue'
import useUserColumns from './columns'
import FilterContainer from '../filter/FilterContainer.vue'
import SingleSelectFilter from '../filter/SingleSelectFilter.vue'
import InstanceFilter from '../filter/InstanceFilter.vue'
import { selectItem, TextField, ValueField } from '@/models/select-item'

const props = defineProps<{
	component: string
}>()

const { columns, custom, all } = useUserColumns(props.component)
</script>

<template>
	<FilterContainer :columns="all" :custom="custom" bookmark="users-bookmark-">
		<div class="p-2 filter-col" v-show="columns.instance.value.isVisible">
			<InstanceFilter v-model="columns.instance.value"></InstanceFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.firstname.value.isVisible">
			<TextFilter data-test="firstname-filter-user" v-model="columns.firstname.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.lastname.value.isVisible">
			<TextFilter data-test="lastname-filter-user" v-model="columns.lastname.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.idCode.value.isVisible">
			<TextFilter data-test="code-filter-user" v-model="columns.idCode.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.email.value.isVisible">
			<TextFilter data-test="email-filter-user" v-model="columns.email.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.aduser.value.isVisible">
			<TextFilter data-test="aduser-filter-user" v-model="columns.aduser.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.active.value.isVisible">
			<SingleSelectFilter
				data-test="active-filter-user"
				:label-field="TextField"
				:value-field="ValueField"
				:options="[selectItem('active', 1), selectItem('notActive', 0)]"
				v-model="columns.active.value"
			></SingleSelectFilter>
		</div>
	</FilterContainer>
</template>
